import React from 'react';
import { MiniCheck } from './ControlPanelHelpers';

const CategoriesTab = ({ selectedCategories, setSelectedCategories, categories }) => (
  <div data-testid="cp-cat-panel">
    <div style={{ fontSize: '0.5rem', color: '#555', marginBottom: 4 }}>CATEGORIES &middot; {selectedCategories.length}/{categories.length} selected</div>
    <div style={{ display: 'flex', gap: 4, marginBottom: 4 }}>
      <button onClick={() => setSelectedCategories(categories.map(c => c.id))} className="btn-ocean"
        style={{ background: 'rgba(16,185,129,0.12)', border: '1px solid rgba(16,185,129,0.25)', color: '#10b981', padding: '2px 6px', borderRadius: 4, fontSize: '0.48rem', cursor: 'pointer' }}>ALL</button>
      <button onClick={() => setSelectedCategories([])} className="btn-ocean"
        style={{ background: 'rgba(239,68,68,0.12)', border: '1px solid rgba(239,68,68,0.25)', color: '#ef4444', padding: '2px 6px', borderRadius: 4, fontSize: '0.48rem', cursor: 'pointer' }}>NONE</button>
    </div>
    <div style={{ maxHeight: 280, overflowY: 'auto' }}>
      {categories.map(cat => (
        <MiniCheck key={cat.id} checked={selectedCategories.includes(cat.id)} color="#3b82f6"
          onChange={() => setSelectedCategories(p => p.includes(cat.id) ? p.filter(id => id !== cat.id) : [...p, cat.id])}
          label={`${cat.name} (${cat.url_count || 0})`} />
      ))}
      {categories.length === 0 && <span style={{ color: '#333', fontSize: '0.5rem' }}>No categories</span>}
    </div>
  </div>
);

export default CategoriesTab;
